import moment from 'moment'
import _ from 'lodash'

export default anonTerminationSummaryCtrl

/** @ngInject */
function anonTerminationSummaryCtrl($state, $scope, $window, $stateParams, $uibModal, AnonTermination, ContactTelephone, ErrorCatcher, terminationToken, cancel) {
    $scope.contactTelephone = ContactTelephone
    $scope.token = terminationToken
    $scope.isLoading = false
    $scope.error = null
    $scope.confirmed = false
    $scope.cancelConfirmed = false
    $scope.cancelMode = cancel
    $scope.reason = {
        choice: null,
        text: '',
    }

    $scope.payload = {
        effectiveDate: moment(),
        enedisEstimation: false,
        reading: {},
    }

    $scope.effectiveDateMin = moment()
    $scope.effectiveDateMax = moment().add(42, 'day')
    $scope.maxLength = 6

    const openErrorModal = (error) => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: require('./errorModal.jade')(),
            controller($scope, $uibModalInstance) {
                $scope.contactTelephone = ContactTelephone
                $scope.error = error

                switch (error.sgeCode) {
                    case 'SGT4B5': $scope.errorCase = 'INDEX'
                        break
                    case 'SGE500':
                    case 'SGT500': $scope.errorCase = 'UNAVAILABLE'
                        break
                    default: $scope.errorCase = 'OTHER'
                }

                $scope.close = () => {
                    $uibModalInstance.dismiss()
                }
            },
        })
    }

    const confirmation = () => {
        $scope.isLoading = true
        $scope.error = null
        const payload = _.cloneDeep($scope.payload)
        payload.effectiveDate = payload.effectiveDate.format('YYYY-MM-DD')
        if (payload.enedisEstimation) {
            delete payload.reading.hp
            delete payload.reading.hc
            delete payload.reading.base
        }
        payload.reason = $scope.reason
        AnonTermination.confirmTermination({ tokenId: $stateParams.tokenId }, payload).$promise.then((terminationResult) => {
            const result = terminationResult.toJSON()
            if (result.success) {
                $scope.confirmed = true
            } else if (result.sgeCode) {
                openErrorModal(result)
            } else {
                $scope.error = { data: result }
            }
        })
        .catch((error) => {
            ErrorCatcher.catchError(error)
            $scope.error = error
        })
        .finally(() => {
            $scope.isLoading = false
        })
    }

    const uncheckEsti = () => {
        $scope.payload.enedisEstimation = false
    }

    const openConfirmModal = () => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: require('./confirmModal.jade')(),
            controller($scope, $uibModalInstance) {
                $scope.close = () => {
                    uncheckEsti()
                    $uibModalInstance.dismiss()
                }
                $scope.confirm = () => {
                    $uibModalInstance.dismiss()
                    confirmation()
                }
            },
        })
    }

    $scope.confirmTermination = () => {
        if ($scope.payload.enedisEstimation && !terminationToken.migratedLinky) {
            openConfirmModal()
        } else {
            confirmation()
        }
    }

    $scope.cancelTermination = () => {
        $scope.error = null
        AnonTermination.cancelTermination({ tokenId: $stateParams.tokenId }).$promise.then((redirectResult) => {
            $scope.cancelConfirmed = true
        })
        .catch((error) => {
            ErrorCatcher.catchError(error)
            $scope.error = error
        })
        .finally(() => {
            $scope.isLoading = false
        })
    }

    $scope.isEffectiveDateValid = () =>
        !$scope.token.migratedLinky || moment($scope.payload.effectiveDate).isBetween($scope.effectiveDateMin, $scope.effectiveDateMax, 'day', '[]')

    $scope.canShoot = () => (
        terminationToken.migratedLinky
        || ($scope.payload.enedisEstimation ||
            (terminationToken.id_p_calendar === 'BASE' && $scope.payload.reading.base) ||
            (terminationToken.id_p_calendar === 'HPHC' && $scope.payload.reading.hp && $scope.payload.reading.hc)
        ))
        && ($scope.reason.choice && ($scope.reason.choice !== 'OTHER' || $scope.reason.text))
        && $scope.isEffectiveDateValid()
}



// WEBPACK FOOTER //
// ./src/states/anonTerminationSummary/anonTerminationSummary.js